import React from "react";
import styled from "styled-components";
import { StyledButton } from "../../CommonUI/BuildlingBlocks/StyledButton";

import { ExpressionValue } from "../../rule-engine-core/Expressions/ExpressionValue";
import { ExpressionValueType } from "../../rule-engine-core/Expressions/ExpressionValueType";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

const Buttons = styled.div`
    display: flex;
    width: 100%;

    > * {
        margin-left: 20px;

        &:first-child {
            margin-left: 0px;
        }
    }
`;

const SelectedButton = styled.div`
    border-bottom: 1px solid ${UIStyleConstants.BLUE_COLOR};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 33%;
    padding: 12px 0 6px;
`;

const NotSelectedButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 33%;
    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
    border-bottom: 1px solid ${UIStyleConstants.GRAY_LIGHTER_COLOR};
    padding: 12px 0 6px;
`;

export const ModeButtons = function (props: { value: ExpressionValue }) {
    return (
        <Buttons>
            <ExpressionButton value={props.value} />
            <VariableButton value={props.value} />
            <ValueButton value={props.value} />
        </Buttons>
    );
};

const ExpressionButton = function (props: { value: ExpressionValue }) {
    function handleClick() {
        props.value.valueType = ExpressionValueType.SUBEXPRESSION;
    }

    if (props.value.valueType === ExpressionValueType.SUBEXPRESSION) {
        return (
            <SelectedButton>
                <StyledButton size="small">Pick Expression</StyledButton>
            </SelectedButton>
        );
    } else {
        return (
            <NotSelectedButton>
                <StyledButton
                    size="small"
                    onClick={handleClick}
                >
                    Pick Expression
                </StyledButton>
            </NotSelectedButton>
        );
    }
};

const VariableButton = function (props: { value: ExpressionValue }) {
    function handleClick() {
        props.value.valueType = ExpressionValueType.VARIABLE;
    }

    if (props.value.valueType === ExpressionValueType.VARIABLE) {
        return (
            <SelectedButton>
                <StyledButton size="small">Pick Data Name</StyledButton>
            </SelectedButton>
        );
    } else {
        return (
            <NotSelectedButton>
                <StyledButton
                    size="small"
                    onClick={handleClick}
                >
                    Pick Data Name
                </StyledButton>
            </NotSelectedButton>
        );
    }
};

const ValueButton = function (props: { value: ExpressionValue }) {
    function handleClick() {
        props.value.valueType = ExpressionValueType.VALUE;
    }

    if (props.value.valueType === ExpressionValueType.VALUE) {
        return (
            <SelectedButton>
                <StyledButton size="small">Enter Data Value</StyledButton>
            </SelectedButton>
        );
    } else {
        return (
            <NotSelectedButton>
                <StyledButton
                    size="small"
                    onClick={handleClick}
                >
                    Enter Data Value
                </StyledButton>
            </NotSelectedButton>
        );
    }
};
